import { createSlice } from "@reduxjs/toolkit";
import ProfileAPIs from "api/Profile/index";
import { requests } from 'api/index';
import URLS  from 'api/endPoints';


// Slice

const initiazUserstate = {
    BASICDETAILS: "",
    CONTACTDETAILS: "",
    EDUCATIONDETAILS: "",
    EMPLOYEMENTDETAILS: "",
    LANGUAGEDETAILS: "",
    RESUMEDETAILS: "",
    PARSEDDETAILS:"",
    SKILLDETAILS:"",
    CERTIFICATIONS:"",
    PUBLICATIONS:"",
    isContact:0
}

const slice = createSlice({
  name: "UserState",
  initialState: {
    info: initiazUserstate,
  },
  reducers: {
    getBasic: (state, action) => {
      state.info.BASICDETAILS = action.payload;
    },
    getContact: (state, action) => {
      state.info.CONTACTDETAILS = action.payload;
    },
    getEducation: (state, action) => {
      state.info.EDUCATIONDETAILS = action.payload;
    },
    getEmployee: (state, action) => {
      // action.payload.map((val, index) => {
      state.info.EMPLOYEMENTDETAILS = action.payload;
      // })
    },
    getlanguage: (state, action) => {
      state.info.LANGUAGEDETAILS = action.payload;
    },
    getCertification: (state, action) => {
      state.info.CERTIFICATIONS = action.payload;
    },
    getPublication: (state, action) => {
      state.info.PUBLICATIONS = action.payload;
    },
    getSkill: (state, action) => {
      state.info.SKILLDETAILS = action.payload;
    },
   setcontact:(state,action) =>{
       state.info.isContact=action.payload;
   }
    
  },
});

export default slice.reducer;

// Actions

const {getBasic,getContact,getEducation,getEmployee,getlanguage,getCertification,getPublication,getSkill,setcontact} = slice.actions
export const getBasicAction = (user) => async dispatch => {
    try {
    let response= await ProfileAPIs.getBasic(user);
    // console.log(response, "from billboard");
    if(response.ResponseCode==100){
      await dispatch(getBasic(response));
    }

    return await returnCode(response);
  } catch (e) {
    return console.error(e.message);
  }
};

export const getContactAction = (user) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.getContact(user);
    // console.log(response.Data, "from getfeaturedapi")
    if(response.ResponseCode==100){
    await dispatch(getContact(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
export const getEducationAction = (user) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.getEducation(user);
    if(response.ResponseCode==100){
    await dispatch(getEducation(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};

export const getEmployeeAction = (user) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.getEmployee(user);
    if(response.ResponseCode==100){
    await dispatch(getEmployee(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};

export const getlanguageAction = (id) => async (dispatch) => {
  try {

    let response = await ProfileAPIs.getlanguage(id);
    if(response.ResponseCode==100){
    await dispatch(getlanguage(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
//postMethod

export const setBasicAction = (user) => async dispatch => {
  try {
  let response= await ProfileAPIs.postBasic(user);
  //await dispatch(getBasic(response));
  return await returnCode(response);
} catch (e) {
  return console.error(e.message);
}
};

export const setContactAction = (user) => async dispatch => {
  try {
  let response= await ProfileAPIs.saveContactInfo(user);
  await dispatch(getContact(response));
  return await returnCode(response);
} catch (e) {
  return console.error(e.message);
}
};
export const setEducationAction = (user) => async dispatch => {
  try {
  let response= await ProfileAPIs.saveAcademicInfo(user);
  //await dispatch(getBasic(response));
  return await returnCode(response);
} catch (e) {
  return console.error(e.message);
}
};
export const setEmploymentAction = (user) => async dispatch => {
  try {
  let response= await ProfileAPIs.saveWorkExperience(user);
  //await dispatch(getBasic(response));
  return await returnCode(response);
} catch (e) {
  return console.error(e.message);
}
};
export const setLanguageAction = (user) => async dispatch => {
  try {
  let response= await ProfileAPIs.saveLanguageInfo(user);
  //await dispatch(getBasic(response));
  return await returnCode(response);
} catch (e) {
  return console.error(e.message);
}
};

export const getSkillAction = (user) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.getSkill(user);
    // console.log(response.Data, "from getfeaturedapi")
    if(response.ResponseCode==100){
    await dispatch(getSkill(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
export const saveSkillAction = (user) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.saveSkill(user);
    // console.log(response.Data, "from getfeaturedapi")
    // if(response.ResponseCode==100){
    // await dispatch(getSkill(response));
    // }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
export const getCertificationAction = (user) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.getCertification(user);
    // console.log(response.Data, "from getfeaturedapi")
    if(response.ResponseCode==100){
    await dispatch(getCertification(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
export const saveCertificationAction = (user) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.saveCertification(user);
    // console.log(response.Data, "from getfeaturedapi")
    // if(response.ResponseCode==100){
    // await dispatch(getSkill(response));
    // }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
export const getPublicationAction = (user) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.getPublication(user);
    // console.log(response.Data, "from getfeaturedapi")
    if(response.ResponseCode==100){
    await dispatch(getPublication(response));
    }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};
export const savePublicationAction = (user) => async (dispatch) => {
  try {
    let response = await ProfileAPIs.savePublication(user);
    // console.log(response.Data, "from getfeaturedapi")
    // if(response.ResponseCode==100){
    // await dispatch(getSkill(response));
    // }
    return await returnCode(response);
  } catch (error) {
    return console.error(error.message);
  }
};

function returnCode(response) {
  if (response.ResponseCode == 100 || 200) {
    return response;
  } else if (response.ResponseCode == 103) {
    return 103;
  } else {
    return 101;
  }
}
